import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select'
import Typography from '@material-ui/core/Typography'

const Dropdown = ({
  field,
  form,
  label,
  options,
  className,
  variant
}) => {
  const fieldValue = get(form.values, field.name)

  return (
    <div className={className}>
      <FormControl fullWidth variant={variant}>
        {label && <Typography className='label' gutterBottom>{label}</Typography>}
        <Select 
          value={fieldValue}
          onChange={e => form.setFieldValue(field.name, e.target.value)} >
          {options.map(option => <MenuItem value={option.id}>{option.name}</MenuItem>)}
        </Select>
      </FormControl>    
    </div>
  )
}

Dropdown.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  label: PropTypes.string,
  renderItem: PropTypes.object,
  options: PropTypes.array,
  className: PropTypes.string,
  variant: PropTypes.string
}

export default Dropdown